<template>
  <DataTable
    v-redirect-if-no-permission:CAR_BRANDS
    :url="api.ACTIONS.CAR_BRANDS"
    :titles="titles"
    :fieldsHiddenMain="['deleted_at']"
    :fieldsHiddenAdd="['id', 'created_at', 'deleted_at', 'updated_at']"
    :fieldsHiddenEdit="['id', 'created_at', 'deleted_at', 'updated_at']"
    :actionsExtraMain="actionsExtraMain"
    :title='$t("catalogPage.pageTitleCarBrands")'
    :fieldsExtraAdd="fieldsExtraAdd"
    :formatter="formatter"
  />
</template>

<script>
import DataTable from "@/components/monaco/DataTable";
import { formatCompanyTime } from "@/util/companyTime";
import api from "@/constants/api.js";

export default {
  name: "CarBrands",
  title() {
    return this.$t("catalogPage.pageTitleBrands");
  },
  components: { DataTable },
  data() {
    return {
      api,
      defaultItem: {
        name_en: "",
        name_ar: "",
      },
    };
  },
  computed: {
    titles() {
      return {
        id: "#",
        name_en: this.$t("catalogPage.colNameEn"),
        name_ar: this.$t("catalogPage.colNameAr"),
        created_at: this.$t("catalogPage.colDateCreated"),
        updated_at: this.$t("catalogPage.colDateUpdated"),
      };
    },
    fieldsExtraAdd() {
      return {
        name_en: "v-text-field",
        name_ar: "v-text-field",
      };
    },
    actionsExtraMain() {
      return {
        models: {
          title: this.$t("catalogPage.modelsAction"),
          color: "secondary",
          action: (item) =>
            this.$router.push({
              name: "CarBrandModels",
              params: { id: item.id },
              query: { name: item.name_en || item.name || this.$t("catalogPage.unknown") },
            }),
        },
      };
    },
    formatter() {
      const vm = this;
      return {
        created_at: (value) => {
          if (!value) return vm.$t("catalogPage.notAvailable");
          return formatCompanyTime(value, "YYYY-MM-DD");
        },
        updated_at: (value) => {
          if (!value) return vm.$t("catalogPage.notAvailable");
          return formatCompanyTime(value, "YYYY-MM-DD");
        },
      };
    },
  },
};
</script>

<style scoped></style>
